/**
 * Javascript file for the page with details on the current reference project. 
 * @author Adrian Rebmann, Yannik Sprengart, Andreas Emrich
 */

import { getProjectByHash } from "../../../../api";
export default {
  name: "ReferenceProjectDetail",
  props: ["hash"],

  /**
   * The vue instance's data object.
   * @property {object} project - The reference project.
   * @property {boolean} loading - Information is currently being processed.
   */
  data() {
    return {
      project: null,
      loading: false
    };
  },

  /**
   * Called after the instance has been created.
   */
  created() {
    this.loading = true;
    getProjectByHash(this.hash)
      .then(res => {
        //console.log(res);
        this.project = res;
        this.loading = false;
      })
      .catch(err => {
        //console.log(err);
        this.loading = false;
      });
  },

  /**
   * The vue instance's method declaration.
   */
  methods: {
    /**
     * Returns to the previously visited page.
     */
    goBack() {
      this.$router.go(-1);
    },

    /**
     * Sets a placeholder image in the element.
     * @param {*} e  - The element where the placeholder image is to be set.
     */
    setAltImg(e) {
      e.target.src = require("../../../../assets/ref-placeholder.png");
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/search/referenceprojectsearch/detail/referenceprojectdetail.js